/* "Complete the gift" cart upsell (snippets/clx-cart-gift.liquid).
   Event delegation on document, because the block's markup is replaced after every cart
   update. Adding uses /cart/add.js with Section Rendering, then repaints the same regions
   Dawn's cart page repaints (items, totals, header bubble, live region) plus this block,
   so an added product drops out of the list. Quantity changes made by Dawn's cart-items
   are picked up through its cartUpdate pub/sub event. */
(function () {
  'use strict';

  var root = window.routes || {};
  var addUrl = (root.cart_add_url || '/cart/add') + '.js';
  var cartUrl = root.cart_url || '/cart';

  function footer() { return document.getElementById('main-cart-footer'); }
  function slot() { return document.querySelector('[data-clx-cg-slot]'); }

  function sectionHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function paint(sections) {
    var items = document.getElementById('main-cart-items');
    var f = footer();
    var targets = [
      { el: items && items.querySelector('.js-contents'), id: items && items.dataset.id, sel: '.js-contents' },
      { el: f && f.querySelector('.js-contents'), id: f && f.dataset.id, sel: '.js-contents' },
      { el: slot(), id: f && f.dataset.id, sel: '[data-clx-cg-slot]' },
      { el: document.getElementById('cart-icon-bubble'), id: 'cart-icon-bubble', sel: '.shopify-section' },
      { el: document.getElementById('cart-live-region-text'), id: 'cart-live-region-text', sel: '.shopify-section' }
    ];
    targets.forEach(function (t) {
      if (!t.el || !t.id || !sections[t.id]) return;
      var html = sectionHTML(sections[t.id], t.sel);
      if (html !== null) t.el.innerHTML = html;
    });
  }

  function sectionIds() {
    var items = document.getElementById('main-cart-items');
    var f = footer();
    return [items && items.dataset.id, f && f.dataset.id, 'cart-icon-bubble', 'cart-live-region-text'].filter(Boolean);
  }

  /* Desktop, columns side by side: line the panel up with the totals column — the
     "Estimated total" pill level with the panel top (the totals column is pushed down,
     so the heading keeps the same gap as the note label), and the panel bottom level with
     the Checkout button. Measured, because that column's height depends on fonts,
     breakpoint and the tax note. */
  function align() {
    var f = footer();
    var gift = f && f.querySelector('.clx-cg');
    if (!gift) return;
    var wrap = f.querySelector('.cart__footer');
    var list = gift.querySelector('.clx-cg__list');
    var pill = f.querySelector('.totals__total-value');
    var btn = f.querySelector('#checkout');
    wrap.style.removeProperty('--clx-cg-blocks-shift');
    gift.style.removeProperty('--clx-cg-list-h');
    if (!list || !pill || !btn) return;
    var l = list.getBoundingClientRect();
    if (btn.getBoundingClientRect().left < l.right) return; // stacked layout (tablet / mobile)
    var shift = Math.max(0, Math.round(l.top - pill.getBoundingClientRect().top));
    wrap.style.setProperty('--clx-cg-blocks-shift', shift + 'px');
    var bottom = btn.getBoundingClientRect().bottom; // re-measured after the shift
    gift.style.setProperty('--clx-cg-list-h', Math.round(bottom - l.top) + 'px');
  }

  var alignQueued = false;
  function queueAlign() {
    if (alignQueued) return;
    alignQueued = true;
    requestAnimationFrame(function () { alignQueued = false; align(); });
  }

  function setMessage(block, text, isError) {
    var msg = block && block.querySelector('.clx-cg__msg');
    if (!msg) return;
    msg.textContent = text || '';
    msg.classList.toggle('clx-cg__msg--error', !!isError);
  }

  function add(button) {
    var block = button.closest('[data-clx-cg]');
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    setMessage(block, '');

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(button.dataset.clxCgAdd), quantity: 1 }],
        sections: sectionIds(),
        sections_url: window.location.pathname
      })
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok || r.data.status) throw new Error(r.data.description || r.data.message || 'Could not add to cart');
        if (r.data.sections) paint(r.data.sections);
        var f = footer();
        if (f) f.classList.remove('is-empty');
        queueAlign();
      })
      .catch(function (err) {
        button.removeAttribute('aria-busy');
        setMessage(block, err.message, true);
      });
  }

  function toggleChoice(opener, force) {
    var panel = document.getElementById(opener.getAttribute('aria-controls'));
    if (!panel) return;
    var open = typeof force === 'boolean' ? force : opener.getAttribute('aria-expanded') !== 'true';
    opener.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;
    if (open) {
      var first = panel.querySelector('.clx-cg__choice-btn:not([disabled])');
      if (first) first.focus();
    }
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-clx-cg] [data-clx-cg-add]');
    if (addBtn) { add(addBtn); return; }
    var opener = e.target.closest('[data-clx-cg] [data-clx-cg-open]');
    if (opener) { toggleChoice(opener); queueAlign(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var panel = e.target.closest && e.target.closest('.clx-cg__choice');
    if (!panel) return;
    var opener = document.querySelector('[aria-controls="' + panel.id + '"]');
    if (opener) { toggleChoice(opener, false); opener.focus(); queueAlign(); }
  });

  window.addEventListener('resize', queueAlign);
  window.addEventListener('load', queueAlign);
  if (document.readyState !== 'loading') { queueAlign(); } else { document.addEventListener('DOMContentLoaded', queueAlign); }

  /* Quantity changed / item removed in Dawn's cart table → re-render this block only */
  /* PUB_SUB_EVENTS is a top-level const in Dawn's constants.js, so it is not on window */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      var f = footer();
      var s = slot();
      if (!f || !s) return;
      fetch(cartUrl + '?section_id=' + encodeURIComponent(f.dataset.id))
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var inner = sectionHTML(html, '[data-clx-cg-slot]');
          if (inner !== null) s.innerHTML = inner;
          queueAlign();
        })
        .catch(function () {});
    });
  }
})();
